<template>
 <div id="app">
    <div class="ui sidebar inverted vertical menu">
      <span class="header item">
        <img id="menu_logo" class="logo" src="../assets/logo.png">
      </span>
      <div class="item">
        <h4 style="margin-bottom:0px;"><i class="user icon" style="float:left;margin-left:0px;margin-right:10px;"></i><span>{{ this.$store.state.user.user }}</span></h4>
      </div>
      <router-link class="item" to="/home">{{$t("components.navbar.Licenses")}}</router-link>
      <router-link class="item" to="/changepassword">{{$t("components.navbar.Change_password")}}</router-link>
      <router-link class="item" to="/about">{{$t("components.navbar.About")}}</router-link>
      <a style="cursor:pointer" class="item" @click="logout()">{{$t("components.navbar.Logout")}}</a>
    </div>
    <div class="pusher">
      <div id="navbar" class="ui secondary menu" v-if="this.$route.path !== '/disconnected' && this.$route.path !== '/login' && !publicSection">
        <button class="ui item menu-button" @click="openMenu">
          <i class="bars icon"></i>
        </button>
      </div>
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<script>
import EventBus from '../utils/event-bus';

export default {

  name: 'navbar',
  props: ['publicSection'],
  data: function () {
    return {
      loginName: 'Administrador',
      env: process.env.NODE_ENV
    };
  },
  methods: {
    openMenu: function () {
      $('.ui.sidebar').sidebar('toggle');
    },
    logout: function () {
      EventBus.$emit('logout');
    }
  },
  updated: function () {
    setTimeout(() => {
      $('.ui.sidebar').sidebar('hide');
      $('#navbar .ui.dropdown').dropdown();
    }, 100);
  },
  mounted: function () {
    setTimeout(() => {
      $('.ui.sidebar').sidebar('hide');
      $('#navbar .ui.dropdown').dropdown();
    }, 100);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
